import React from 'react';
import {Link} from 'react-router-dom';
import {motion} from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const {FiStar,FiPhone,FiMapPin,FiClock,FiUsers,FiAward,FiHeart,FiCalendar,FiCheck,FiTrendingUp,FiShield,FiZap}=FiIcons;

const Home=()=> {
  const services=[
    {title: 'Wedding Decorations',description: 'Make your special day magical with our elegant wedding decoration packages',image: 'https://i.ibb.co/Cp933BqZ/wedding-image.jpg'},
    {title: 'Birthday Parties',description: 'Celebrate another year of life with colorful and fun birthday decorations',image: 'https://i.ibb.co/dJ0gX1bJ/birthday-image.jpg'},
    {title: 'Corporate Events',description: 'Professional and sophisticated decorations for your business events',image: 'https://i.ibb.co/7Js0yrrg/corporate-image.jpg'},
    {title: 'Anniversary Celebrations',description: 'Create lasting memories with beautiful anniversary decoration themes',image: 'https://i.ibb.co/PvQk4vck/anniversary-image.webp'}
  ];

  const features=[
    {icon: FiAward,title: 'Premium Quality',description: 'High-quality decorations and materials for lasting beauty'},
    {icon: FiUsers,title: 'Expert Team',description: 'Professional decorators with years of experience'},
    {icon: FiClock,title: '24/7 Support',description: 'Available round the clock for consultations and support'},
    {icon: FiHeart,title: 'Custom Designs',description: 'Personalized decorations tailored to your vision'},
    {icon: FiShield,title: 'Satisfaction Guaranteed',description: 'We stand behind our work with a 100% satisfaction guarantee'},
    {icon: FiZap,title: 'Quick Setup',description: 'Efficient and professional setup within your timeline'}
  ];

  const testimonials=[
    {name: 'Sarah Johnson',text: 'Stars Event Decor transformed our wedding into a fairy tale. The attention to detail was incredible!',rating: 5,event: 'Wedding'},
    {name: 'Mike Chen',text: 'Professional service and beautiful decorations for our corporate event. Highly recommended!',rating: 5,event: 'Corporate Event'},
    {name: 'Emily Davis',text: 'They made my daughter\'s birthday party absolutely magical. She still talks about it!',rating: 5,event: 'Birthday Party'},
    {name: 'Robert Wilson',text: 'The anniversary decorations were beyond our expectations. Thank you for making our day special!',rating: 5,event: 'Anniversary'},
    {name: 'Lisa Martinez',text: 'Amazing work on our baby shower! Everything was perfect and the setup was so quick.',rating: 5,event: 'Baby Shower'},
    {name: 'James Taylor',text: 'Best holiday party decorations we\'ve ever had. Our guests were blown away!',rating: 5,event: 'Holiday Party'}
  ];

  const recentEvents=[
    {type: 'Wedding',location: 'Scarborough Convention Centre',date: 'Dec 15,2024'},
    {type: 'Corporate Event',location: 'Toronto Marriott',date: 'Dec 10,2024'},
    {type: 'Birthday Party',location: 'Private Residence',date: 'Dec 8,2024'},
    {type: 'Anniversary',location: 'Royal York Hotel',date: 'Dec 5,2024'}
  ];

  return (
    <div className="w-full">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-red-800 to-red-900 text-white py-20">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <motion.div initial={{opacity: 0,x: -50}} animate={{opacity: 1,x: 0}} transition={{duration: 0.8}} className="space-y-6">
              <h1 className="text-4xl md:text-6xl font-bold leading-tight">
                Transform Your <span className="block text-yellow-400">Special Moments</span>
              </h1>
              <p className="text-xl text-red-100 leading-relaxed">
                Professional event decoration services in Scarborough,ON. We create magical experiences that make your celebrations unforgettable with our creative and elegant decor solutions.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <Link to="/contact" className="bg-yellow-400 text-red-900 px-8 py-4 rounded-lg font-semibold hover:bg-yellow-300 transition-colors duration-200 text-center">
                  Get Free Quote
                </Link>
                <a href="tel:+14163207474" className="bg-transparent border-2 border-white text-white px-8 py-4 rounded-lg font-semibold hover:bg-white hover:text-red-800 transition-colors duration-200 text-center flex items-center justify-center space-x-2">
                  <SafeIcon icon={FiPhone} className="w-5 h-5" />
                  <span>Call Now</span>
                </a>
              </div>
              <div className="flex items-center space-x-6 pt-4">
                <div className="flex items-center space-x-2">
                  <SafeIcon icon={FiStar} className="w-5 h-5 text-yellow-400" />
                  <span className="font-semibold">5.0 Rating</span>
                </div>
                <div className="flex items-center space-x-2">
                  <SafeIcon icon={FiUsers} className="w-5 h-5 text-yellow-400" />
                  <span className="font-semibold">500+ Happy Clients</span>
                </div>
              </div>
            </motion.div>
            <motion.div initial={{opacity: 0,x: 50}} animate={{opacity: 1,x: 0}} transition={{duration: 0.8,delay: 0.2}} className="relative">
              <img src="https://i.ibb.co/Cp933BqZ/wedding-image.jpg" alt="Beautiful wedding decoration" className="rounded-lg shadow-2xl w-full h-96 object-cover" />
              <div className="absolute -bottom-6 -left-6 bg-white text-red-800 p-4 rounded-lg shadow-lg">
                <div className="flex items-center space-x-2">
                  <SafeIcon icon={FiAward} className="w-6 h-6 text-red-800" />
                  <span className="font-bold">Award Winning</span>
                </div>
                <p className="text-sm text-gray-600">Best Decorator 2024</p>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            {[
              {number: '500+',label: 'Events Completed'},
              {number: '5+',label: 'Years Experience'},
              {number: '100%',label: 'Client Satisfaction'},
              {number: '24/7',label: 'Support Available'}
            ].map((stat,index)=> (
              <motion.div key={index} initial={{opacity: 0,y: 50}} whileInView={{opacity: 1,y: 0}} transition={{duration: 0.8,delay: index * 0.1}} viewport={{once: true}} className="text-center">
                <div className="text-4xl md:text-5xl font-bold text-red-800 mb-2">{stat.number}</div>
                <div className="text-gray-600 font-medium">{stat.label}</div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Services Preview */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <motion.div initial={{opacity: 0,y: 50}} whileInView={{opacity: 1,y: 0}} transition={{duration: 0.8}} viewport={{once: true}} className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">Our Complete Event Solutions</h2>
            <p className="text-gray-600 text-lg max-w-2xl mx-auto">
              From intimate gatherings to grand celebrations, we specialize in creating stunning decorations that reflect your unique style and vision.
            </p>
          </motion.div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {services.map((service,index)=> (
              <motion.div key={index} initial={{opacity: 0,y: 50}} whileInView={{opacity: 1,y: 0}} transition={{duration: 0.8,delay: index * 0.1}} viewport={{once: true}} className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
                <img src={service.image} alt={service.title} className="w-full h-48 object-cover" />
                <div className="p-6">
                  <h3 className="text-xl font-semibold text-gray-800 mb-2">{service.title}</h3>
                  <p className="text-gray-600 mb-4">{service.description}</p>
                  <Link to="/services" className="text-red-800 font-semibold hover:text-red-900 transition-colors duration-200">
                    Learn More →
                  </Link>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Features */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <motion.div initial={{opacity: 0,y: 50}} whileInView={{opacity: 1,y: 0}} transition={{duration: 0.8}} viewport={{once: true}} className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">Why Choose Stars Event Decor?</h2>
            <p className="text-gray-600 text-lg max-w-2xl mx-auto">
              We bring creativity, professionalism, and attention to detail to every event, ensuring your celebration is nothing short of spectacular.
            </p>
          </motion.div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {features.map((feature,index)=> (
              <motion.div key={index} initial={{opacity: 0,y: 50}} whileInView={{opacity: 1,y: 0}} transition={{duration: 0.8,delay: index * 0.1}} viewport={{once: true}} className="text-center space-y-4">
                <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto">
                  <SafeIcon icon={feature.icon} className="w-8 h-8 text-red-800" />
                </div>
                <h3 className="text-xl font-semibold text-gray-800">{feature.title}</h3>
                <p className="text-gray-600">{feature.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Recent Events */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <motion.div initial={{opacity: 0,y: 50}} whileInView={{opacity: 1,y: 0}} transition={{duration: 0.8}} viewport={{once: true}} className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">Recent Events</h2>
            <p className="text-gray-600 text-lg">Check out some of our latest successful events</p>
          </motion.div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {recentEvents.map((event,index)=> (
              <motion.div key={index} initial={{opacity: 0,y: 50}} whileInView={{opacity: 1,y: 0}} transition={{duration: 0.8,delay: index * 0.1}} viewport={{once: true}} className="bg-white p-6 rounded-lg shadow-md">
                <h3 className="text-lg font-semibold text-red-800 mb-2">{event.type}</h3>
                <p className="text-gray-600 text-sm mb-1">{event.location}</p>
                <p className="text-gray-500 text-xs">{event.date}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <motion.div initial={{opacity: 0,y: 50}} whileInView={{opacity: 1,y: 0}} transition={{duration: 0.8}} viewport={{once: true}} className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">What Our Clients Say</h2>
            <p className="text-gray-600 text-lg">Don't just take our word for it - hear from our satisfied customers</p>
          </motion.div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {testimonials.map((testimonial,index)=> (
              <motion.div key={index} initial={{opacity: 0,y: 50}} whileInView={{opacity: 1,y: 0}} transition={{duration: 0.8,delay: index * 0.1}} viewport={{once: true}} className="bg-white p-6 rounded-lg shadow-lg">
                <div className="flex items-center mb-4">
                  {[...Array(testimonial.rating)].map((_,i)=> (
                    <SafeIcon key={i} icon={FiStar} className="w-5 h-5 text-yellow-400" />
                  ))}
                </div>
                <p className="text-gray-600 mb-4 italic">"{testimonial.text}"</p>
                <div className="border-t pt-4">
                  <p className="font-semibold text-gray-800">- {testimonial.name}</p>
                  <p className="text-sm text-red-600">{testimonial.event}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <motion.div initial={{opacity: 0,y: 50}} whileInView={{opacity: 1,y: 0}} transition={{duration: 0.8}} viewport={{once: true}} className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">Our Simple Process</h2>
            <p className="text-gray-600 text-lg max-w-2xl mx-auto">Four easy steps to make your event unforgettable</p>
          </motion.div>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            {[
              {step: '1',title: 'Consultation',description: 'We discuss your vision and requirements'},
              {step: '2',title: 'Design Planning',description: 'Create custom decoration plan tailored to your event'},
              {step: '3',title: 'Professional Setup',description: 'Expert installation on your event day'},
              {step: '4',title: 'Cleanup & Support',description: 'Complete cleanup and ongoing support'}
            ].map((process,index)=> (
              <motion.div key={index} initial={{opacity: 0,y: 50}} whileInView={{opacity: 1,y: 0}} transition={{duration: 0.8,delay: index * 0.1}} viewport={{once: true}} className="text-center">
                <div className="w-20 h-20 bg-red-800 text-white rounded-full flex items-center justify-center mx-auto mb-4 text-2xl font-bold">
                  {process.step}
                </div>
                <h3 className="text-xl font-semibold text-gray-800 mb-2">{process.title}</h3>
                <p className="text-gray-600">{process.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Special Offers */}
      <section className="py-16 bg-gradient-to-r from-red-700 to-red-900 text-white">
        <div className="container mx-auto px-4 text-center">
          <motion.div initial={{opacity: 0,y: 50}} whileInView={{opacity: 1,y: 0}} transition={{duration: 0.8}} viewport={{once: true}} className="max-w-4xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold mb-6">Limited Time Offer!</h2>
            <p className="text-xl text-red-100 mb-8">
              Book your event decoration now and get 20% off on our Premium Package
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-8">
              <div className="flex items-center space-x-2">
                <SafeIcon icon={FiCheck} className="w-6 h-6 text-yellow-400" />
                <span>Free Consultation</span>
              </div>
              <div className="flex items-center space-x-2">
                <SafeIcon icon={FiCheck} className="w-6 h-6 text-yellow-400" />
                <span>No Hidden Fees</span>
              </div>
              <div className="flex items-center space-x-2">
                <SafeIcon icon={FiCheck} className="w-6 h-6 text-yellow-400" />
                <span>Satisfaction Guaranteed</span>
              </div>
            </div>
            <Link to="/contact" className="bg-yellow-400 text-red-900 px-8 py-4 rounded-lg font-semibold hover:bg-yellow-300 transition-colors duration-200 inline-block">
              Claim Your Discount
            </Link>
          </motion.div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-red-800 text-white">
        <div className="container mx-auto px-4 text-center">
          <motion.div initial={{opacity: 0,y: 50}} whileInView={{opacity: 1,y: 0}} transition={{duration: 0.8}} viewport={{once: true}} className="max-w-3xl mx-auto space-y-6">
            <h2 className="text-3xl md:text-4xl font-bold">Ready to Make Your Event Unforgettable?</h2>
            <p className="text-xl text-red-100">
              Contact us today for a free consultation and let's bring your vision to life. Our team is ready to create the perfect atmosphere for your special occasion.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link to="/contact" className="bg-yellow-400 text-red-900 px-8 py-4 rounded-lg font-semibold hover:bg-yellow-300 transition-colors duration-200 flex items-center justify-center space-x-2">
                <SafeIcon icon={FiCalendar} className="w-5 h-5" />
                <span>Book Consultation</span>
              </Link>
              <a href="tel:+14163207474" className="bg-transparent border-2 border-white text-white px-8 py-4 rounded-lg font-semibold hover:bg-white hover:text-red-800 transition-colors duration-200 flex items-center justify-center space-x-2">
                <SafeIcon icon={FiPhone} className="w-5 h-5" />
                <span>+1 (416) 320-7474</span>
              </a>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default Home;